const stats = [
  { value: "42", label: "Apartamentos" },
  { value: "3", label: "Blocos A · B · C" },
  { value: "T0–T4", label: "Tipologias" },
  { value: "A+", label: "Classe Energética" },
  { value: "4 000", label: "m² de Jardim" },
];

export default function StatsStrip() {
  return (
    <section data-testid="stats-strip" className="bg-[#2B3B31] text-[#F9F9F6]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-5 divide-x divide-[#F9F9F6]/15 border-x border-[#F9F9F6]/0">
          {stats.map((s, i) => (
            <div
              key={s.label}
              data-testid={`stat-${i}`}
              className={`flex flex-col items-start gap-2 py-8 lg:py-10 px-5 lg:px-8 ${i >= 2 ? "border-t md:border-t-0 border-[#F9F9F6]/15" : ""}`}
            >
              <div className="font-display text-3xl lg:text-5xl font-light tracking-tight">{s.value}</div>
              <div className="text-[11px] tracking-[0.22em] uppercase text-[#F9F9F6]/70">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
